export default function getBaseType(type: any) {
  return type.includes('_REQUEST') ? type.slice(0, -8) : type;
}
